var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"wp-like-menu-item"},[_c('a',{staticClass:"wp-like-menu-item-link",attrs:{"href":_vm.menuItemData.link},domProps:{"textContent":_vm._s(_vm.menuItemData.name)}}),(_vm.menuItemData.children && _vm.menuItemData.children.length > 0)?_c('WPLikeSubMenu',{attrs:{"subMenuItemsData":_vm.menuItemData.children}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }